import React from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';

const InactivityModal: React.FC<Props> = ({ onClose, onLogin, visible }) =>
	visible ? (
		<Modal onClose={onClose} bg wrapperClassName="_w-1/2 _mx-auto">
			<ModalBody>
				<h2>Session Expired</h2>
				<p>You have been logged out because you have been inactive for some time, please log in again to continue</p>
				<button className="_btn _btn-black" onClick={onLogin}>
					Login
				</button>
			</ModalBody>
		</Modal>
	) : null;

interface Props {
	onClose: () => void;
	onLogin: () => void;
	visible: boolean;
}

const ModalBody = styled.div`
	text-align: center;
	padding: 1.5rem;

	h2 {
		font-size: 2.2rem;
		margin-bottom: 1rem;
	}

	p {
		color: red;
		margin-bottom: 1rem;
	}
`;

export default InactivityModal;
